/**
 * Player Logger Utility
 *
 * Wraps the standard logger with debug settings to provide
 * more granular control over player-related logging.
 */

import DEBUG from "util/debugSettings";
import rootLogger from "util/logger";

// Standard loggers
const musicPlayerLogger = rootLogger.getLogger("MusicPlayer");
const mediaSessionLogger = rootLogger.getLogger("MediaSession");

// Wrapper functions for different log categories
export const playerLogger = {
  // For player state transitions (high-level events)
  state: {
    debug: (message: string, ...args: any[]) => {
      if (DEBUG.PLAYER_STATE) {
        musicPlayerLogger.debug(message, ...args);
      }
    },
    info: musicPlayerLogger.info.bind(musicPlayerLogger),
    warn: musicPlayerLogger.warn.bind(musicPlayerLogger),
    error: musicPlayerLogger.error.bind(musicPlayerLogger),
  },

  // For player implementation details (play/pause/load calls)
  impl: {
    debug: (message: string, ...args: any[]) => {
      if (DEBUG.PLAYER_IMPLEMENTATION) {
        musicPlayerLogger.debug(message, ...args);
      }
    },
    info: musicPlayerLogger.info.bind(musicPlayerLogger),
    warn: musicPlayerLogger.warn.bind(musicPlayerLogger),
    error: musicPlayerLogger.error.bind(musicPlayerLogger),
  },

  // Always log critical messages
  critical: {
    debug: musicPlayerLogger.debug.bind(musicPlayerLogger),
    info: musicPlayerLogger.info.bind(musicPlayerLogger),
    warn: musicPlayerLogger.warn.bind(musicPlayerLogger),
    error: musicPlayerLogger.error.bind(musicPlayerLogger),
  },
};

// Media session logger wrapper
export const mediaLogger = {
  // For media session updates
  debug: (message: string, ...args: any[]) => {
    if (DEBUG.MEDIA_SESSION) {
      mediaSessionLogger.debug(message, ...args);
    }
  },
  info: mediaSessionLogger.info.bind(mediaSessionLogger),
  warn: mediaSessionLogger.warn.bind(mediaSessionLogger),
  error: mediaSessionLogger.error.bind(mediaSessionLogger),
};

export default {
  player: playerLogger,
  media: mediaLogger,
};
